import XHRMock, { sequence } from 'xhr-mock';
import { GET_EMPTY_SESSION_MARKER_RESPONSE, GET_SESSION_MARKER_RESPONSE } from './responses';
import {
  FetchSessionMarkersResponse,
  SearchServicePublic,
} from '@fullstory/proto/fs/services/alexa';

export const getSessionMarkersMock = (mock: typeof XHRMock, rsp = GET_SESSION_MARKER_RESPONSE) =>
  mock.post(SearchServicePublic.FetchSessionMarkersEndpoint, (_, resp) =>
    resp.status(200).body(rsp),
  );

export const getEmptySessionMarkersThenFilledSessionMarkersMock = (
  mock: typeof XHRMock,
  resp1 = GET_EMPTY_SESSION_MARKER_RESPONSE,
  resp2: Partial<FetchSessionMarkersResponse> = GET_SESSION_MARKER_RESPONSE,
) =>
  mock.post(
    SearchServicePublic.FetchSessionMarkersEndpoint,
    sequence([
      (_, resp) => resp.status(200).body(resp1),
      (_, resp) => resp.status(200).body(resp2),
    ]),
  );
